var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.isOverlay
    ? _c(
        "article",
        {
          staticClass: "cmp cmp-product-thumb cmp-product-thumb--grid",
          on: {
            mouseleave: function($event) {
              return _vm.loadNewImage(
                _vm.thumbForMain.firstImage.urlSecondPreview,
                "",
                ""
              )
            }
          }
        },
        [
          _c("div", { staticClass: "category-item__wrapper" }, [
            _vm.catIdsReverseImage
              ? _c(
                  "div",
                  { ref: "catImg", staticClass: "category-item__image" },
                  [
                    _vm.newUrl !== ""
                      ? _c(
                          "a",
                          {
                            staticClass: "d-block",
                            attrs: { href: _vm.newUrl }
                          },
                          [
                            _c("img", {
                              staticClass:
                                "img-fluid category-item__image-img lazy-img",
                              class: "category-item__image-img-0",
                              attrs: {
                                "data-src":
                                  _vm.item.images.all[0].urlSecondPreview,
                                src:
                                  "https://bilder.weberbuero.de/frontend/images/shop/loading085.svg",
                                alt: _vm._f("itemName")(_vm.item)
                              }
                            })
                          ]
                        )
                      : _c(
                          "a",
                          {
                            staticClass: "d-block",
                            attrs: { href: _vm._f("itemURL")(_vm.item, false) }
                          },
                          [
                            _c("img", {
                              staticClass:
                                "img-fluid category-item__image-img lazy-img",
                              class: "category-item__image-img-0",
                              attrs: {
                                "data-src":
                                  _vm.item.images.all[0].urlSecondPreview,
                                src:
                                  "https://bilder.weberbuero.de/frontend/images/shop/loading085.svg",
                                alt: _vm._f("itemName")(_vm.item)
                              }
                            })
                          ]
                        ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn category-item__quick-view",
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.openQuickView()
                          }
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$translate("Weberbuero::Template.quickView")
                          )
                        )
                      ]
                    )
                  ]
                )
              : _c(
                  "div",
                  { ref: "catImg", staticClass: "category-item__image" },
                  [
                    _vm.newUrl !== ""
                      ? _c(
                          "a",
                          {
                            staticClass: "d-block",
                            attrs: { href: _vm.newUrl }
                          },
                          _vm._l(_vm.images.slice(0, 1), function(
                            image,
                            index
                          ) {
                            return _c("img", {
                              staticClass:
                                "img-fluid category-item__image-img lazy-img",
                              class: "category-item__image-img-0",
                              attrs: {
                                "data-src": image.urlSecondPreview,
                                src:
                                  "https://bilder.weberbuero.de/frontend/images/shop/loading085.svg",
                                alt: _vm._f("itemName")(_vm.item)
                              }
                            })
                          }),
                          0
                        )
                      : _c(
                          "a",
                          {
                            staticClass: "d-block",
                            attrs: { href: _vm._f("itemURL")(_vm.item, false) }
                          },
                          _vm._l(_vm.images.slice(0, 1), function(
                            image,
                            index
                          ) {
                            return _c("img", {
                              staticClass:
                                "img-fluid category-item__image-img lazy-img",
                              class: "category-item__image-img-0",
                              attrs: {
                                "data-src": image.urlSecondPreview,
                                src:
                                  "https://bilder.weberbuero.de/frontend/images/shop/loading085.svg",
                                alt: _vm._f("itemName")(_vm.item)
                              }
                            })
                          }),
                          0
                        ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn category-item__quick-view",
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.openQuickView()
                          }
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$translate("Weberbuero::Template.quickView")
                          )
                        )
                      ]
                    )
                  ]
                ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "category-item__content" },
              [
                _vm.isLoading
                  ? _c("div", { staticClass: "category-item__crossselling" }, [
                      _c("img", {
                        attrs: {
                          src:
                            "https://bilder.weberbuero.de/frontend/images/shop/loading085.svg",
                          height: "34px"
                        }
                      })
                    ])
                  : Array.isArray(_vm.crossseller) && _vm.crossseller.length > 0
                  ? _c(
                      "div",
                      { staticClass: "category-item__crossselling" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "category-item__crossselling-item d-none d-md-flex"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "category-item__img-container",
                                attrs: {
                                  "data-image":
                                    _vm.thumbForMain.firstImage.urlSecondPreview
                                },
                                on: {
                                  mouseover: function($event) {
                                    return _vm.loadNewImage(
                                      _vm.thumbForMain.firstImage
                                        .urlSecondPreview,
                                      "",
                                      ""
                                    )
                                  }
                                }
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: _vm._f("itemURL")(_vm.item, false),
                                      title: _vm._f("itemName")(_vm.item)
                                    }
                                  },
                                  [
                                    _c("div", {
                                      staticClass:
                                        "category-item__crossselling-img",
                                      style:
                                        "background-image: url(" +
                                        _vm.thumbForMain.thumb +
                                        ")"
                                    })
                                  ]
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _vm._l(_vm.crossseller, function(cross, key) {
                          return _vm.crossseller.length > 0
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "category-item__crossselling-item d-none d-md-flex",
                                  class: {
                                    "category-item__crossselling-item--last":
                                      key + 1 == 4
                                  }
                                },
                                [
                                  key + 1 < 4
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "category-item__img-container",
                                          attrs: {
                                            "data-image":
                                              cross.images.firstImage
                                                .urlSecondPreview
                                          },
                                          on: {
                                            mouseover: function($event) {
                                              return _vm.loadNewImage(
                                                cross.images.firstImage
                                                  .urlSecondPreview,
                                                cross.texts.urlPath,
                                                cross.item.id
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              attrs: {
                                                href:
                                                  "/" +
                                                  cross.texts.urlPath +
                                                  "/a-" +
                                                  cross.item.id,
                                                title: cross.texts.name1
                                              }
                                            },
                                            [
                                              _c("div", {
                                                staticClass:
                                                  "category-item__crossselling-img",
                                                style:
                                                  "background-image: url(" +
                                                  cross.images.thumb +
                                                  ")"
                                              })
                                            ]
                                          )
                                        ]
                                      )
                                    : key + 1 == 4
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "category-item__img-container number-indicator d-flex align-items-center justify-content-center",
                                          class:
                                            _vm.crossseller.length - 3 > 9
                                              ? "small-font"
                                              : ""
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              attrs: {
                                                href: _vm._f("itemURL")(
                                                  _vm.item,
                                                  _vm.urlWithVariationId
                                                )
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "+ " +
                                                  _vm._s(
                                                    _vm.crossseller.length - 3
                                                  )
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              )
                            : _vm._e()
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-md-none category-item__crossseller-mobile category-item__variations-indicator"
                          },
                          [
                            _c("img", {
                              staticClass: "category-item__shape",
                              attrs: {
                                src:
                                  _vm.pluginPath +
                                  "/images/icons/configurate_shape.png"
                              }
                            }),
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.crossseller.length) +
                                " " +
                                _vm._s(
                                  _vm.$translate(
                                    "Weberbuero::Template.itemMoreVariations"
                                  )
                                ) +
                                "\n                "
                            )
                          ]
                        )
                      ],
                      2
                    )
                  : _vm.variationsCount > 1
                  ? _c(
                      "div",
                      { staticClass: "category-item__variations-indicator" },
                      [
                        _vm.item.filter.hasChildren
                          ? _c("div", [
                              _c("img", {
                                staticClass: "category-item__shape",
                                attrs: {
                                  src:
                                    _vm.pluginPath +
                                    "/images/icons/configurate_shape.png"
                                }
                              }),
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.variationsCount) +
                                  " " +
                                  _vm._s(
                                    _vm.$translate(
                                      "Weberbuero::Template.itemMoreVariations"
                                    )
                                  ) +
                                  "\n                "
                              )
                            ])
                          : _c("div", [
                              _c("img", {
                                staticClass: "category-item__shape",
                                attrs: {
                                  src:
                                    _vm.pluginPath +
                                    "/images/icons/configurate_shape.png"
                                }
                              }),
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm.$translate(
                                      "Weberbuero::Template.itemMoreVariations"
                                    )
                                  ) +
                                  "\n                "
                              )
                            ])
                      ]
                    )
                  : _c("div", [
                      _c("div", {
                        staticClass: "category-item__crossseller-ws"
                      })
                    ]),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "category-item__itemname",
                    attrs: { href: _vm._f("itemURL")(_vm.item) }
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm._f("itemName")(_vm.item)) +
                        "\n            "
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "prices category-item__prices" }, [
                  _c("div", { staticClass: "price" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(
                          _vm._f("specialOffer")(
                            _vm.item.prices.default.unitPrice.formatted,
                            _vm.item.prices,
                            "unitPrice",
                            "formatted"
                          )
                        ) +
                        "\n                "
                    )
                  ]),
                  _vm._v(" "),
                  _vm.item.prices.rrp &&
                  _vm.item.prices.rrp.price.value > 0 &&
                  _vm.item.prices.rrp.price.value >
                    _vm.item.prices.default.unitPrice.value
                    ? _c("div", { staticClass: "price-view-port" }, [
                        _vm.item.prices.specialOffer
                          ? _c("del", { staticClass: "crossprice" }, [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm._f("itemCrossPrice")(
                                      _vm.item.prices.default.unitPrice
                                        .formatted,
                                      true
                                    )
                                  ) +
                                  "\n                    "
                              )
                            ])
                          : _c("del", { staticClass: "crossprice" }, [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm._f("itemCrossPrice")(
                                      _vm.item.prices.rrp.unitPrice.formatted
                                    )
                                  ) +
                                  "\n                    "
                              )
                            ])
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _vm._t("after-prices"),
                _vm._v(" "),
                _c("div", { staticClass: "category-item__availability" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.item.variation.availability.names.name) +
                      "\n            "
                  )
                ])
              ],
              2
            )
          ])
        ]
      )
    : _c("article", [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-4" }, [
            _c("div", { ref: "catImg", staticClass: "category-item__image" }, [
              _c(
                "a",
                {
                  staticClass: "d-block",
                  attrs: { href: _vm._f("itemURL")(_vm.item, false) }
                },
                _vm._l(_vm.item.images.all.slice(0, 1), function(image, index) {
                  return _c("img", {
                    staticClass: "img-fluid category-item__image-img",
                    class: "category-item__image-img-0",
                    attrs: {
                      src: image.urlSecondPreview,
                      alt: _vm._f("itemName")(_vm.item)
                    }
                  })
                }),
                0
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-8" },
            [
              _c(
                "a",
                {
                  staticClass: "category-item__itemname",
                  attrs: { href: _vm._f("itemURL")(_vm.item) }
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm._f("itemName")(_vm.item)) +
                      "\n            "
                  )
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "prices" }, [
                _c("div", { staticClass: "price" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(
                        _vm._f("specialOffer")(
                          _vm.item.prices.default.unitPrice.formatted,
                          _vm.item.prices,
                          "unitPrice",
                          "formatted"
                        )
                      ) +
                      "\n                "
                  )
                ]),
                _vm._v(" "),
                _vm.item.prices.rrp &&
                _vm.item.prices.rrp.price.value > 0 &&
                _vm.item.prices.rrp.price.value >
                  _vm.item.prices.default.price.value
                  ? _c("div", { staticClass: "price-view-port" }, [
                      _vm.item.prices.specialOffer
                        ? _c("del", { staticClass: "crossprice" }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm._f("itemCrossPrice")(
                                    _vm.item.prices.default.unitPrice.formatted,
                                    true
                                  )
                                ) +
                                "\n                    "
                            )
                          ])
                        : _c("del", { staticClass: "crossprice" }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm._f("itemCrossPrice")(
                                    _vm.item.prices.rrp.unitPrice.formatted
                                  )
                                ) +
                                "\n                    "
                            )
                          ])
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _vm._t("after-prices"),
              _vm._v(" "),
              _c("add-to-basket", {
                attrs: {
                  "data-testing": "item-add-to-basket",
                  "variation-id": _vm.item.variation.id,
                  "is-salable": !!_vm.item.filter && _vm.item.filter.isSalable,
                  "has-children":
                    !!_vm.item.item && _vm.item.item.salableVariationCount > 1,
                  "interval-quantity":
                    _vm.item.variation.intervalOrderQuantity || 1,
                  "minimum-quantity": _vm.item.variation.minimumOrderQuantity,
                  "maximum-quantity":
                    !!_vm.item.variation.maximumOrderQuantity &&
                    _vm.item.variation.maximumOrderQuantity > 0
                      ? _vm.item.variation.maximumOrderQuantity
                      : null,
                  "order-properties": _vm.item.properties.filter(function(
                    prop
                  ) {
                    return prop.property.isOderProperty
                  }),
                  "has-order-properties": _vm.item.hasOrderProperties,
                  "has-required-order-property":
                    _vm.item.hasRequiredOrderProperty,
                  "use-large-scale": false,
                  "show-quantity": true,
                  "item-url": _vm._f("itemURL")(
                    _vm.item,
                    _vm.urlWithVariationId
                  ),
                  "has-graduated-price":
                    _vm.itemGraduatedPriceisCheapestSorting ||
                    _vm.itemGraduatedPricesalableVariationCount,
                  "has-price": _vm._f("hasItemDefaultPrice")(_vm.item),
                  "item-type": _vm.item.item.itemType,
                  "is-overlay": _vm.isOverlay
                }
              })
            ],
            2
          )
        ])
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }